import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { Router } from 'react-router-dom';
import WobiThemeProvider from 'wobi-web-common/dist/components/WobiThemeProvider';
import { IntlProvider } from 'react-intl';
import messages_he from './messages/he';
import rollbar from './config/rollbar';
import TagManager from 'react-gtm-module';
import { createBrowserHistory } from 'history';
import patchBlockFn from 'history-block-async';
import { agentDeveloperUtils } from 'wobi-web-common/dist/components/utils/helpers';

const defaultLanguage = 'he';
const messages = {
  he: messages_he,
};

window.rollbar = rollbar;

const gtmEnv = {
  gtmId: agentDeveloperUtils.getGtmId(),
};
TagManager.initialize(gtmEnv);

const AdditionalGtmIdArr = agentDeveloperUtils.getAdditionalTagManegerIds();
if (AdditionalGtmIdArr && Array.isArray(AdditionalGtmIdArr) && AdditionalGtmIdArr.length > 0) {
  for (const additionalGtmId of AdditionalGtmIdArr) {
    const additionalGtmEnviroment = {
      gtmId: additionalGtmId,
    };
    TagManager.initialize(additionalGtmEnviroment);
  }
}

const history = patchBlockFn(createBrowserHistory());

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <IntlProvider locale={defaultLanguage} messages={messages[defaultLanguage]}>
    <WobiThemeProvider>
      <Router history={history}>
        <App />
      </Router>
    </WobiThemeProvider>
  </IntlProvider>
);